import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonhireinbhor() {



  const cardData =
  {
    keyword: 'Bus On Hire in Bhor',
    heading: 'Sanavi Travels: Bus On Hire in Bhor',
    headingDescription: 'Bus On Hire in Bhor services are ideal for comfortable and affordable group travel for weddings, school trips, corporate events, picnics, religious tours, and outstation journeys. We provide AC and Non-AC buses, mini buses, and luxury coaches in multiple seating capacities such as 17, 20, 26, 32, 35, 40, 45, and 50 seater buses, all well-maintained and driven by experienced chauffeurs. With flexible rental packages, transparent pricing, punctual service, and 24/7 booking support, bus hire in Bhor ensures safe, convenient, and stress-free travel for local trips as well as long-distance tours from Bhor to Pune, Mahabaleshwar, Konkan, Goa, and other destinations.',

    top: 'Top Places to Visit in Bhor with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhor Town",
    "description": "Bhor is a historic town in Pune district, once the capital of the former Bhor princely state. Nestled in the Sahyadri ranges, the town is known for its pleasant climate, rich cultural heritage, and scenic surroundings. Bhor offers a peaceful blend of history, rural life, and natural beauty, making it a calm retreat away from crowded tourist destinations."
  },
  {
    "title": "Bhor Rajwada (Royal Palace)",
    "description": "The Bhor Rajwada is a reminder of the town’s princely past. This heritage structure reflects traditional Maratha-era architecture and stands as a symbol of Bhor’s historical importance. Though simple in design, it gives visitors insight into the royal legacy and governance of the region."
  },
  {
    "title": "Bhatghar Dam",
    "description": "Bhatghar Dam is one of the oldest masonry dams in India, built on the Yelwandi River. Surrounded by hills and greenery, the dam creates a vast reservoir that offers stunning views, especially during the monsoon season. It is a popular spot for nature lovers, photographers, and those seeking quiet scenic escapes."
  },
  {
    "title": "Neera River Valley",
    "description": "The Neera River flows near Bhor, forming fertile valleys and scenic landscapes. The riverbanks are ideal for short walks, picnics, and enjoying peaceful moments amidst nature. During monsoon, the valley turns lush green, enhancing the beauty of the region."
  },
  {
    "title": "Baneshwar Temple and Forest",
    "description": "Located near Bhor, Baneshwar Temple is an ancient Shiva temple surrounded by a protected forest area. The Baneshwar forest is rich in biodiversity and offers nature trails, picnic spots, and a tranquil environment. The temple is especially vibrant during Mahashivratri celebrations."
  },
  {
    "title": "Varandha Ghat",
    "description": "Varandha Ghat is a scenic mountain pass connecting Bhor to Mahad in the Konkan region. Known for its breathtaking views, waterfalls, and deep valleys, the ghat is a favorite route for monsoon drives, bikers, and nature enthusiasts."
  },
  {
    "title": "Raireshwar Temple",
    "description": "Raireshwar Temple, located near Bhor, is historically significant as the place where Chhatrapati Shivaji Maharaj took an oath of Swarajya. Dedicated to Lord Shiva, the temple sits atop a hill and offers panoramic views along with deep spiritual and historical importance."
  },
  {
    "title": "Hill Treks and Nature Trails",
    "description": "The hills surrounding Bhor provide excellent opportunities for trekking, hiking, and nature walks. Trails pass through forests, streams, and open plateaus, making them ideal for adventure seekers and nature lovers, especially during the monsoon season."
  },
  {
    "title": "Village Life and Rural Culture",
    "description": "Bhor’s surrounding villages reflect authentic rural Maharashtrian culture. Visitors can experience traditional farming practices, local festivals, warm hospitality, and simple village life set against a scenic natural backdrop."
  },
  {
    "title": "Sunset Viewpoints",
    "description": "Several viewpoints around Bhor offer mesmerizing sunset views over hills, rivers, and valleys. These spots are perfect for relaxation, photography, and enjoying the calm beauty of the Sahyadri landscape."
  }
]
,



"services": [
{
"name": "Bus On Hire in Bhor",
"description": "Bus On Hire in Bhor provides reliable and comfortable buses for local and outstation travel. Perfect for families, groups, and tourists, these buses are well-maintained and equipped for long journeys, ensuring a smooth, safe, and enjoyable travel experience. Professional drivers, flexible schedules, and spacious seating make it an ideal choice for weddings, corporate trips, sightseeing tours, and group outings in and around Bhor."
},
{
"name": "Bus Rental Bhor",
"description": "Bus Rental Bhor offers convenient and flexible bus rental services for various occasions including group trips, corporate events, weddings, and long-distance travel. With modern buses, professional drivers, and personalized itineraries, it guarantees a comfortable, safe, and stress-free journey for all passengers traveling to and from Bhor."
},
{
"name": "AC Bus Bhor",
"description": "AC Bus Bhor provides air-conditioned buses for a cool and comfortable travel experience. Ideal for long-distance travel, family trips, corporate tours, and tourist excursions, these buses ensure passengers enjoy a relaxing ride with well-maintained interiors, smooth driving, and professional drivers who prioritize safety and convenience."
},
{
"name": "Luxury Bus Bhor",
"description": "Luxury Bus Bhor offers high-end buses with premium seating, spacious interiors, and modern amenities for corporate groups, VIP travelers, and long-distance trips. Combining comfort, style, and safety, these buses are perfect for weddings, events, and tourist journeys, providing a sophisticated and enjoyable travel experience in and around Bhor."
},
{
"name": "Wedding Bus Bhor",
"description": "Wedding Bus Bhor specializes in providing elegant and spacious buses for wedding parties and related events. With comfortable seating, professional drivers, and timely service, it ensures smooth transportation for guests, family members, and relatives, making wedding travel organized, safe, and hassle-free."
},
{
"name": "Corporate Bus Bhor",
"description": "Corporate Bus Bhor provides professional and efficient transport solutions for companies, offices, and corporate events. With punctual service, modern buses, and experienced drivers, it ensures employees and business teams travel safely and comfortably for meetings, conferences, team outings, and airport transfers in and around Bhor."
},
{
"name": "Outstation Bus Bhor",
"description": "Outstation Bus Bhor offers reliable and comfortable buses for long-distance travel to nearby cities, tourist destinations, and hill stations. With well-maintained vehicles, professional drivers, and flexible itineraries, it ensures safe, convenient, and enjoyable journeys for families, groups, and corporate travelers venturing out of Bhor."
},
{
"name": "Affordable Bus Bhor",
"description": "Affordable Bus Bhor provides budget-friendly bus rental services without compromising on comfort or safety. Ideal for students, families, corporate groups, and tourists, these buses combine economical pricing with spacious seating, reliable drivers, and timely service, offering a convenient and safe travel solution in and around Bhor."
},
{
"name": "Chauffeur Driven Bus Bhor",
"description": "Chauffeur Driven Bus Bhor ensures a stress-free travel experience with professional drivers managing navigation, traffic, and schedules. Perfect for weddings, corporate trips, group outings, and tourist travel, it guarantees a smooth, safe, and comfortable journey for all passengers traveling to and from Bhor."
},
{
"name": "Best Bus Service Bhor",
"description": "Best Bus Service Bhor is known for punctuality, clean and modern buses, and professional drivers. Catering to families, groups, corporate clients, and tourists, it provides reliable, comfortable, and safe transportation for all occasions including events, outings, and long-distance travel from Bhor."
},
{
"name": "Tourist Bus Bhor",
"description": "Tourist Bus Bhor caters to travelers exploring Bhor and nearby attractions. With flexible itineraries, comfortable buses, and experienced drivers, it provides a seamless and enjoyable sightseeing experience, allowing tourists to explore cultural, historical, and scenic locations without any hassle."
},
{
"name": "Group Travel Bus Bhor",
"description": "Group Travel Bus Bhor specializes in transporting friends, families, corporate teams, and social groups efficiently and comfortably. With spacious seating, professional drivers, and organized schedules, it ensures smooth and coordinated travel for group outings, events, and tours originating from Bhor."
},
{
"name": "Online Bus Booking Bhor",
"description": "Online Bus Booking Bhor allows passengers to reserve buses quickly and conveniently with instant confirmation. Offering multiple bus options, transparent pricing, and flexible scheduling, it simplifies travel planning for families, groups, corporate clients, and tourists traveling to or from Bhor."
},
{
"name": "Event Bus Bhor",
"description": "Event Bus Bhor provides dedicated bus services for weddings, corporate events, parties, and other special occasions. With professional drivers, spacious and well-maintained buses, and reliable scheduling, it ensures organized, safe, and comfortable transportation for all event attendees in and around Bhor."
},
{
"name": "Bhor Travel Bus",
"description": "Bhor Travel Bus offers comprehensive bus rental solutions for local commuting, tourist trips, corporate travel, weddings, and outstation journeys. Combining safety, comfort, reliability, and professional service, it caters to families, groups, corporate clients, and tourists seeking convenient and hassle-free bus travel in Bhor and surrounding areas."
}
],
"tableData": [
["Bus On Hire in Bhor", "Bus Rental Bhor"],
["AC Bus Bhor", "Luxury Bus Bhor"],
["Wedding Bus Bhor", "Corporate Bus Bhor"],
["Outstation Bus Bhor", "Affordable Bus Bhor"],
["Chauffeur Driven Bus Bhor", "Best Bus Service Bhor"],
["Tourist Bus Bhor", "Group Travel Bus Bhor"],
["Online Bus Booking Bhor", "Event Bus Bhor"],
["Bhor Travel Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Hire in Bhor with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus hire services in Bhor, ideal for group outings, school trips, family tours, and corporate travel."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Bhor and nearby areas."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with the Bhor region, ensuring safe, punctual, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for bus hire in Bhor, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to help with bookings, travel queries, and itinerary planning for your bus hire in Bhor."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized bus hire packages based on your group’s needs and travel schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus hire in Bhor."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire services in Bhor?',
    answer: 'Yes, Sanavi Travels offers dependable bus hire services in Bhor for various group travel needs.'
  },
  {
    question: 'How can I book a bus in Bhor?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for hire in Bhor?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20‑seater, 32‑seater, 45‑seater, and 50‑seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Bhor?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with routes around Bhor, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations in Bhor?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Bhor and nearby areas.'
  },
  {
    question: 'Is the bus hire service in Bhor available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock bus hire services in Bhor to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus hire services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus hire bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Bhor.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Shinde',
    feedback: 'We booked a bus hire in Bhor with Sanavi Travels — excellent service and comfortable journey!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Sanavi Travels provided a clean and reliable bus for our trip in Bhor. Highly recommended!',
    rating: 5
  }
];






















































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusOrCoach",
  "name": "Bus On Hire in Bhor - Sanavi Travels",
  "description": "Sanavi Travels offers AC and luxury buses on hire in Bhor for weddings, corporate events, tourist trips, group travel, and outstation journeys. Affordable, chauffeur-driven buses with online booking available.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "42"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Bus On Hire in Bhor | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC and luxury buses on hire in Bhor with Sanavi Travels. Perfect for weddings, corporate trips, group travel, and tourist journeys. Chauffeur-driven, affordable, and online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/143.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonhireinbhor;